import React from "react";

const light = () => {
  return (
    <svg
      width="44"
      height="42"
      viewBox="0 0 44 42"
      fill="none"
      data-setthemeto="Light"
    >
      <ellipse
        cx="21.5"
        cy="24"
        rx="17.5"
        ry="18"
        fill="white"
        data-setthemeto="Light"
      />
      <rect
        x="9"
        y="3.4783"
        width="0.850335"
        height="7"
        rx="0.425167"
        transform="rotate(-28.5758 9 3.4783)"
        fill="white"
        data-setthemeto="Light"
      />
      <rect
        x="4"
        y="7.40671"
        width="0.850335"
        height="7"
        rx="0.425167"
        transform="rotate(-28.5758 4 7.40671)"
        fill="white"
        data-setthemeto="Light"
      />
      <rect
        x="0.824463"
        y="14.5404"
        width="0.850335"
        height="7"
        rx="0.425167"
        transform="rotate(-32.1621 0.824463 14.5404)"
        fill="white"
        data-setthemeto="Light"
      />
      <rect
        x="1"
        y="22.4526"
        width="0.850335"
        height="7"
        rx="0.425167"
        transform="rotate(-32.1621 1 22.4526)"
        fill="white"
        data-setthemeto="Light"
      />
      <rect
        x="16.6082"
        y="1.04492"
        width="0.850335"
        height="7"
        rx="0.425167"
        transform="rotate(-7.3444 16.6082 1.04492)"
        fill="white"
        data-setthemeto="Light"
      />
      <rect
        x="23.2406"
        y="1.0062"
        width="0.850335"
        height="7"
        rx="0.425167"
        transform="rotate(1.38619 23.2406 1.0062)"
        fill="white"
        data-setthemeto="Light"
      />
      <rect
        x="31.461"
        y="2.26901"
        width="0.850335"
        height="7"
        rx="0.425167"
        transform="rotate(29.839 31.461 2.26901)"
        fill="white"
        data-setthemeto="Light"
      />
      <rect
        x="36.3495"
        y="5.41766"
        width="0.850335"
        height="7"
        rx="0.425167"
        transform="rotate(31.0969 36.3495 5.41766)"
        fill="white"
        data-setthemeto="Light"
      />
      <rect
        x="41.2492"
        y="11"
        width="0.850335"
        height="7"
        rx="0.425167"
        transform="rotate(48.5805 41.2492 11)"
        fill="white"
        data-setthemeto="Light"
      />
      <rect
        x="43.2492"
        y="17"
        width="0.850335"
        height="7"
        rx="0.425167"
        transform="rotate(48.5805 43.2492 17)"
        fill="white"
        data-setthemeto="Light"
      />
      <rect
        x="42.2492"
        y="24"
        width="0.850335"
        height="7"
        rx="0.425167"
        transform="rotate(48.5805 42.2492 24)"
        fill="white"
        data-setthemeto="Light"
      />
    </svg>
  );
};

export default light;
